import { Box, Divider, Flex } from "@chakra-ui/react";
import { Icons, Typography } from "@reconvert/react-ui-component";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectAppState, setActivePage } from "../../app/slice/appSlice";
import { navigateTo } from "../../app/slice/mobileSlice";
import { LinkItem } from "../../app/slice/appSlice.model";
import { useFlowBuilderSession } from "@reconvert/react-ui-component";
import { APP_PREFIX } from "../../config";
import { IFramePostMessageType, sendPostMessage } from "../../utils/helpers";

const MobileLocationsScreen = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { sideBarSections } = useAppSelector(selectAppState);
  const { setPageInSession } = useFlowBuilderSession();
  const handleLocationTap = (link: LinkItem) => {
    if (link.disabled) return;

    setPageInSession(link.type);
    dispatch(setActivePage(link.type));
    dispatch(navigateTo("conditions"));
  };

  return (
    <Box h="100%" w="100%" bg="white" overflowY="auto">
      <Flex alignItems="center" px="16px" py="12px" w="100%">
        <Flex alignItems="center" justifyContent="flex-start" w="40px" flexShrink={0}>
          <Icons.CaretLeft
            onClick={() => {
              sendPostMessage(IFramePostMessageType.EXIT_CONDITION_EDITOR );  
            }}
          />
        </Flex>
        <Flex alignItems="center" justifyContent="center" gap="8px" flex={1} minW={0}>
          <img
            src={APP_PREFIX + "/Upsell.com-only-blue-logo_black-text 1.svg"}
            alt="Upsell.com logo"
            style={{ width: "32px", height: "32px", display: "block", flexShrink: 0 }}
          />
          <img
            src={APP_PREFIX + "/Upsell.com-blue-logo_black-text.svg"}
            alt="Upsell.com"
            style={{ width: "126px", height: "24px", display: "block" }}
          />
        </Flex>
        <Box w="40px" flexShrink={0} aria-hidden />
      </Flex>

      {sideBarSections
        .filter(section => section.enabled && section.links.length > 0)
        .map((section, sectionIndex) => (
          <Box key={section.name}>
            <Box px="16px" pt="20px" pb="8px">
              <Typography
                variant="small"
                color="neutrals.600"
                fontWeight={600}
                textTransform="uppercase"
                letterSpacing="0.5px"
              >
                {t(section.name)}
              </Typography>
            </Box>
            <Flex border="1px solid" borderColor="neutrals.300" borderRadius="10px" flexDirection="column" m="12px">
              {section.links.map((link, index) => (
                <Box key={link.type}>
                  <Flex
                    alignItems="center"
                    px="16px"
                    py="14px"
                    cursor={link.disabled ? "not-allowed" : "pointer"}
                    opacity={link.disabled ? 0.5 : 1}
                    _hover={!link.disabled ? { bg: "neutrals.100" } : undefined}
                    onClick={() => handleLocationTap(link)}
                  >
                    <Box mr="12px" flexShrink={0}>
                      {link.icon}
                    </Box>
                    <Typography variant="body" fontWeight={500} flex={1}>
                      {t(link.name)}
                    </Typography>
                    <Icons.CaretRight color="neutrals.500" />
                  </Flex>
                  {index < section.links.length - 1 && <Divider my="1px" />}
                </Box>
              ))}
            </Flex>
          </Box>
        ))}
    </Box>
  );
};

export default MobileLocationsScreen;
